(function(){
    'use strict';

    let getAlertStorage = function(){
        let storageVal = localStorage.getItem('globalAlertsDismissed');
        let isHidden = (storageVal === 'true');
        return isHidden;
    };
    let setAlertStorage = function(value){
        localStorage.setItem('globalAlertsDismissed', value);
    };

    let showAlerts = function(){
        for (let elem of toggledAlerts) {
            elem.classList.remove('sr-only');
        }
        alertsToggler.classList.remove('global-alerts__toggle--hidden');
        alertsToggler.classList.add('global-alerts__toggle--visible');
        setAlertStorage('false');
    };
    let hideAlerts = function(){
        for (let elem of toggledAlerts) {
            elem.classList.add('sr-only');
        }
        alertsToggler.classList.remove('global-alerts__toggle--visible');
        alertsToggler.classList.add('global-alerts__toggle--hidden');
        setAlertStorage('true');
    };

    let globalAlerts = document.querySelector('.global-alerts');
    let toggledAlerts = document.querySelectorAll('.global-alerts__alert--canhide');
    let alertsToggler = document.querySelector('.global-alerts__toggle');
    let immutableAlerts = document.querySelectorAll('.global-alerts__alert--red');

    if(globalAlerts && toggledAlerts && toggledAlerts.length > 0){
        document.body.classList.add('has-global-alerts');
        // alerts are hidden
        if(getAlertStorage()){
            console.log('hidden alerts');
            // Add the .color-blue class
            if(toggledAlerts){
                hideAlerts();
            }
        } else {
            // alerts are visible
        }
        // show parent alert block
        globalAlerts.classList.remove('global-alerts--hidden');

        alertsToggler.addEventListener("click", function() {
            // if alerts are hidden, show them
            if(getAlertStorage()){
                showAlerts();
            } else {
                // else hide them
                hideAlerts();
            }

        });
    } else {
        alertsToggler.remove();
        if(immutableAlerts && immutableAlerts.length > 0){
            // show parent alert block
            globalAlerts.classList.remove('global-alerts--hidden');
        }
    }



}());
